import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Typography,
  TextField,
} from "@mui/material";

import Box from "@mui/material/Box";
import axios from "axios";
import { format, parse, isValid } from "date-fns";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../context";
import { getProfessions } from "../services/api";
import {
  validateCellphone,
  validateCpf,
  validateEmail,
  yearsOld,
} from "../services/utils";
import AlertField from "./Alert";
import { TextInput } from "./Input";
import { MaskInput } from "./MaskInput";
import { PrimaryButton } from "./PrimaryButton";
import { SelectInput } from "./SelectInput";

export const Form = () => {
  const {
    createLead,
    plan,
    lead,
    setLoading,
    optionalFields,
    maxAge,
    minAge,
    setLead,
    subAccountId,
  } = useContext<any>(AppContext);
  const [professionValue, setProfessionValue] = useState("");
  const [professionOption, setProfessionOption] = useState<any>([]);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [salary, setSalary] = useState("");
  const [statusCivil, setStatusCivil] = useState("");
  const [sex, setSex] = useState("");
  const [exposed, setExposed] = useState("");
  const [name, setName] = useState("");
  const [preferredName, setPreferredName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [cpf, setCpf] = useState("")
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [dialogProps, setDialogProps] = useState({
    message: "",
    url: "",
  });

  useEffect(() => {
    console.log({ plan });
    createProfessionList();
    updateValue();
    formatedBirthday();
  }, []);

  useEffect(() => {
    setLead({
      name,
      preferredName,
      birthday,
      sex,
    });
  }, [name, birthday, sex, preferredName]);

  useEffect(() => {
    
    if(cpf && cpf.replace(/\D/g, "").length === 11 && birthday) {
      const parsedBirthday = parse(birthday, "dd/MM/yyyy", new Date())
      if(isValid(parsedBirthday) && validateCpf(cpf)) {
        searchCpf()
      }
    }
  },[cpf, birthday])

  const formatedBirthday = () => {
    if (lead.birthday) {
      const formatedBirthday = format(
        parse(lead.birthday, "yyyy-MM-dd", new Date()),
        "dd/MM/yyyy"
      );
      setBirthday(formatedBirthday);
    }
  };

  const updateValue = () => {
    setStatusCivil(lead.status_civil);
    setSex(lead.sex);
    setExposed(lead.exposed);
    setProfessionValue(lead.profession);
    setSalary(lead.salary);
  };

  const handleClose = () => {
    setOpenAlert(false);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    window.location.reload();
  };

  const createProfessionList = async () => {
    const professions = await getProfessions();
    setProfessionOption(professions);
  };

  const handleProfession = (value: any) => {
    setProfessionValue(value);
  };

  const handleExposed = (value: any) => {
    setExposed(value);
  };

  const handlerCPF = async (e: any) => {
    const cpfValid = e.replace(/\D/g, "")
    setCpf(cpfValid)
    if(!validateCpf(cpfValid) && cpfValid.length === 11) {
      setAlertMessage("CPF Inválido!");
      setOpenAlert(true);
    }
  }

  const handlerBirthday = async (e: any) => {
    setBirthday(e)
  }

  const searchCpf = async () => {
    if (cpf) {
      setLoading(true);
      try {
        const bodySearch = {
          cpf,
          birthday,
          selected_product: plan.plan_selected,
          subAccountId: subAccountId,
        };
        
        const existsLead = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/leads/existslead`,
          headers: { "Content-Type": "application/json" },
          data: bodySearch,
        });
        if (
          existsLead.data &&
          existsLead.data.existsLeads &&
          (existsLead.data.existsLeadsSubscribed ||
            existsLead.data.existsLeadsAwaitPayment)
        ) {
          setDialogProps({
            message: existsLead.data.existsLeadsMessage,
            url: existsLead.data.existsLeadsUrlBankslip,
          });
          setOpenDialog(true);
        } else {
          const params = new URLSearchParams();
          params.append("cpf", cpf)
          params.append("birthday", birthday)
          const res = await axios({
            method: "get",
            url: `${process.env.REACT_APP_API_BRIA}/search`,
            headers: {
              Authorization: `${process.env.REACT_APP_API_KEY}`,
            },
            params
          });
          if (res) {
            setName(res.data.name);
            setPreferredName(res.data.name);
            setSex(res.data.sex);
          }
        }
        setLoading(false);
      } catch (e: any) {
        setLoading(false);
      }
    }
    
  };

  const statusOptions = [
    { value: "Solteiro", label: "Solteiro" },
    { value: "Casado", label: "Casado" },
    { value: "Separado", label: "Separado" },
    { value: "Divorciado", label: "Divorciado" },
    { value: "Viúvo", label: "Viúvo" },
  ];

  const salaryOptions = [
    { value: "1500", label: "Até R$ 1.500" },
    { value: "3000", label: "Entre R$ 1.500 e R$ 3.000" },
    { value: "5000", label: "Superior a R$ 3.000" },
  ];

  const exposedOptions = [
    { value: "true", label: "Sim" },
    { value: "false", label: "Não" },
  ];

  const genderOptions = [
    { value: "M", label: "Masculino" },
    { value: "F", label: "Feminino" },
    { value: "O", label: "Outro" },
  ];

  const handleSalary = (value: string) => {
    setSalary(value);
  };

  const handleStatus = (value: string) => {
    setStatusCivil(value);
  };

  const handleGender = (value: string) => {
    setSex(value);
  };

  const handlerPreferredname = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPreferredName(value);
  };

  const history = useHistory();

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const data = {
      cpf: e.target?.cpf.value.replace(/\D/g, ""),
      birthday: e.target?.birthday.value,
      sex: sex,
      name: e.target?.name.value,
      status_civil: statusCivil,
      profession: professionValue,
      salary: salary,
      exposed: exposed,
      email: e.target?.email.value,
      emailConfirm: e.target?.emailConfirm.value,
      cellphone: e.target?.cellphone.value.replace(/\D/g, ""),
      preferredName,
    };

    const age = yearsOld(data.birthday);

    if (!data.cpf) {
      setAlertMessage("CPF não informado!");
      setOpenAlert(true);
    } else if (!data.birthday) {
      setAlertMessage("Data de nascimento não informada!");
      setOpenAlert(true);
    } else if (age < minAge) {
      setAlertMessage(`A idade mínima é de ${minAge} anos para esse produto!`);
      setOpenAlert(true);
    } else if (age > maxAge) {
      setAlertMessage(`A idade máxima é de ${maxAge} anos para esse produto!`);
      setOpenAlert(true);
    } else if (!data.sex) {
      setAlertMessage("Sexo não selecionado!");
      setOpenAlert(true);
    } else if (!data.name) {
      setAlertMessage("Nome não informado!");
      setOpenAlert(true);
    } else if (!data.preferredName) {
      setAlertMessage("Nome social não informado!");
      setOpenAlert(true);
    } else if (!data.status_civil) {
      setAlertMessage("Estado civil não informado!");
      setOpenAlert(true);
    } else if (!data.email) {
      setAlertMessage("Email não informado!");
      setOpenAlert(true);
    } else if (!validateEmail(data.email)) {
      setAlertMessage("Email Inválido!");
      setOpenAlert(true);
    } else if (data.emailConfirm !== data.email) {
      setAlertMessage("Emails não coincidem!");
      setOpenAlert(true);
    } else if (!data.cellphone) {
      setAlertMessage("Telefone não informado!");
      setOpenAlert(true);
    } else if (!validateCellphone(data.cellphone)) {
      setAlertMessage("Telefone inválido!");
      setOpenAlert(true);
    } else if (!validateCpf(data.cpf)) {
      setAlertMessage("CPF Inválido!");
      setOpenAlert(true);
    } else if (optionalFields.exposed && !data.exposed) {
      setAlertMessage("Politicamente Exposto não selecionada!");
      setOpenAlert(true);
    } else if (optionalFields.profession && !data.profession) {
      setAlertMessage("Profissão não selecionada!");
      setOpenAlert(true);
    } else if (optionalFields.salary && !data.salary) {
      setAlertMessage("Média Salarial não selecionada!");
      setOpenAlert(true);
    } else {
      const formatedDate = format(
        parse(e.target?.birthday.value, "dd/MM/yyyy", new Date()),
        "yyyy-MM-dd"
      );
      const metaData = {
        name: e.target?.name.value,
        cpf: e.target?.cpf.value.replace(/\D/g, ""),
        status_civil: statusCivil,
        birthday: formatedDate,
        sex: sex,
        profession: professionValue,
        salary: salary,
        exposed: exposed,
        selected_product: plan.plan_selected,
        mql: true,
        email: e.target?.email.value,
        emailConfirm: e.target?.emailConfirm.value,
        cellphone: e.target?.cellphone.value.replace(/\D/g, ""),
        product_value: plan.price,
        preferredName,
      };

      const res = createLead(metaData);
      if (res) {
        history.push("/endereco");
      }
    }
  };

  const getGridSize = () => (plan.preferredNameOption ? 6 : 4);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "background.default",
      }}
    >
      <Paper
        variant="outlined"
        elevation={2}
        sx={{
          backgroundColor: "background.default",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <AlertField
              message={alertMessage}
              status={openAlert}
              handle={handleClose}
            />
          </Box>

          <Grid
            container
            sx={{ px: 4, py: plan.preferredNameOption ? 1 : 3, maxWidth: 900 }}
            rowSpacing={1}
            spacing={1}
          >
            {plan.preferredNameOption && (
              <Grid item xs={12}>
                <Typography variant="body2" gutterBottom>
                  * Preenchimento do Nome Social é obrigatório.
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <MaskInput
                  defaultValue={lead.cpf}
                  mask="999.999.999-99"
                  id="cpf"
                  handle={handlerCPF}
                  label="CPF"
                  value={lead ? lead.cpf : ""}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <MaskInput
                  defaultValue={lead.birthday}
                  mask="99/99/9999"
                  id="birthday"
                  handle={handlerBirthday}
                  label="Nascimento"
                  value={birthday}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <SelectInput
                  defaultValue={lead.sex}
                  label="Sexo"
                  id="sex"
                  options={genderOptions}
                  handleClick={handleGender}
                  value={sex}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.name}
                  id="name"
                  label="Nome"
                  value={lead.name}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <SelectInput
                  defaultValue={lead.status_civil}
                  label="Estado Civil"
                  id="status_civil"
                  options={statusOptions}
                  handleClick={handleStatus}
                />
              </Box>
            </Grid>
            {plan.preferredNameOption && (
              <>
                <Grid item xs={12} sm={8}>
                  <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                    <TextField
                      defaultValue={lead.preferredName}
                      fullWidth
                      value={preferredName}
                      color="secondary"
                      id="preferred-name"
                      label="Nome Social"
                      variant="outlined"
                      size="small"
                      onChange={handlerPreferredname}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                    <MaskInput
                      defaultValue={lead.cellphone}
                      mask="(99) 99999-9999"
                      id="cellphone"
                      label="Telefone"
                      value={lead ? lead.cellphone : ""}
                    />
                  </Box>
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={getGridSize()}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput defaultValue={lead.email} id="email" label="Email" />
              </Box>
            </Grid>
            <Grid item xs={12} sm={getGridSize()}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.email}
                  id="emailConfirm"
                  label="Confirme seu Email"
                />
              </Box>
            </Grid>
            {!plan.preferredNameOption && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <MaskInput
                    defaultValue={lead.cellphone}
                    mask="(99) 99999-9999"
                    id="cellphone"
                    label="Telefone"
                    value={lead ? lead.cellphone : ""}
                  />
                </Box>
              </Grid>
            )}
            {optionalFields.exposed && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <SelectInput
                    defaultValue={lead.exposed}
                    label="Exposto Politicamente"
                    id="exposed"
                    handleClick={handleExposed}
                    options={exposedOptions}
                  />
                </Box>
              </Grid>
            )}
            {professionOption && optionalFields.profession && (
              <Grid item xs={12} sm={4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    maxWidth: 260,
                  }}
                >
                  <SelectInput
                    defaultValue={lead.profession}
                    label="Profissão"
                    id="profession"
                    options={professionOption}
                    handleClick={handleProfession}
                  />
                </Box>
              </Grid>
            )}
            {optionalFields.salary && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <SelectInput
                    defaultValue={lead.salary}
                    label="Média Salarial"
                    id="salary"
                    options={salaryOptions}
                    handleClick={handleSalary}
                  />
                </Box>
              </Grid>
            )}
          </Grid>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <PrimaryButton name="Prosseguir" />
          </Box>
        </form>
      </Paper>
      <Dialog
        open={openDialog}
        scroll="paper"
        aria-labelledby="lead-exists"
        aria-describedby="lead-exists"
      >
        <DialogTitle color="secondary" id="scroll-dialog-title">
          Olá! É um pazer ver você novamente.
        </DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText id="scroll-dialog-description">
            <Typography color="primary" gutterBottom>
              {dialogProps.message}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {dialogProps.url && (
            <Button
              variant="contained"
              target="_blank"
              rel="noreferrer"
              href={dialogProps.url}
              size="small"
              // color="secondary"
            >
              BAIXAR BOLETO
            </Button>
          )}
          <Button onClick={handleCloseDialog} style={{ marginLeft: 10 }}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
